/**
 * Stable Mixpanel event names. Never embed dynamic IDs, UUIDs, or status codes here.
 * See src/analytics/README.md and mixpanel.ts for naming rules.
 *
 * When adding or renaming events: update member_portal_lexicon.csv, run
 * scripts/normalize-member-portal-lexicon.mjs, then upload to Mixpanel Lexicon
 * (test + prod, Replace unchecked) — see README "Lexicon" section.
 */
export const ANALYTICS_EVENTS = {
  AUTH_COMPLETED: "auth_completed",
  AUTH_FAILED: "auth_failed",

  DASHBOARD_CTA_CLICKED: "dashboard_cta_clicked",

  SURVEY_STARTED: "survey_started",
  SURVEY_COMPLETED: "survey_completed",
  SURVEY_SAVE_FAILED: "survey_save_failed",
  SURVEY_PARSE_FAILED: "survey_parse_failed",
  SURVEY_ABANDON_ATTEMPTED: "survey_abandon_attempted",

  KIT_ORDER_WORKFLOW_STARTED: "kit_order_workflow_started",
  KIT_SELECTION_CONFIRMATION_RESOLVED: "kit_selection_confirmation_resolved",
  KIT_ORDER_SUBMITTED: "kit_order_submitted",
  KIT_ORDER_BATCH_COMPLETED: "kit_order_batch_completed",

  FORM_SUBMISSION_COMPLETED: "form_submission_completed",

  RESULTS_REVIEW_STARTED: "results_review_started",
  RESULTS_REVIEW_COMPLETED: "results_review_completed",
  RESULTS_REVIEW_DECISION: "results_review_decision",
  RESULTS_DOWNLOAD_COMPLETED: "results_download_completed",
  RESULTS_DOWNLOAD_FAILED: "results_download_failed",

  ACCOUNT_MFA_COMPLETED: "account_mfa_completed",
  ACCOUNT_MFA_FAILED: "account_mfa_failed",
  PASSWORD_RESET_REQUESTED: "password_reset_requested",

  PAYMENT_COMPLETED: "payment_completed",
  PAYMENT_FAILED: "payment_failed",

  SPOUSE_INVITE_COMPLETED: "spouse_invite_completed",
  SPOUSE_INVITE_FAILED: "spouse_invite_failed",

  SHARE_GENOMIC_LIFE_PATH_SELECTED: "share_genomic_life_path_selected",

  MEMBERSHIP_INVITE_COMPLETED: "membership_invite_completed",
  MEMBERSHIP_INVITE_FAILED: "membership_invite_failed",

  GIFT_MEMBERSHIP_WORKFLOW_STARTED: "gift_membership_workflow_started",
  GIFT_CHECKOUT_LINK_COMPLETED: "gift_checkout_link_completed",
  GIFT_CHECKOUT_LINK_FAILED: "gift_checkout_link_failed"
} as const;

export type AnalyticsEventName =
  (typeof ANALYTICS_EVENTS)[keyof typeof ANALYTICS_EVENTS];
